var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"domoTs"},[_c('el-button',{on:{"click":_vm.a}},[_vm._v("aaa")]),_c('HelloWorld',{attrs:{"msg":_vm.body}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }